export const layers = (zoom) => [
  {
    "id": "favorites",
    "type": "symbol",
    "source": "favorites",
    "minzoom": 7,
    "maxzoom": 15,
    'layout': {
      'icon-image': 'favorite-marker',
      'icon-size': 0.16,
      'icon-anchor': 'top',
      'icon-offset': [-40, -180]
    }
  },
  {
    "id": "favorites-lowzoom",
    "type": "symbol",
    "source": "favorites",
    "minzoom": 15,
    'layout': {
      'icon-image': 'favorite-marker',
      'icon-size': 0.20,
      'icon-anchor': 'top',
      'icon-offset': [-20, -180]
    }
  }
]
